import { Popover } from "antd";
import { Trans, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { useState } from "react";
import ModalDiagnose from "./ModalDiagnose";
import {
  dataLayerClickedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { AssessmentClickEventName } from "event-tracker/button-click-event-name";

const { REACT_APP_DIAGNOSE_EXAMPLE } = process.env;
interface PanelDiagnosticButtonsProps {
  teamId?: string;
  getTeams: () => void;
}

const PopoverContent = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: 300,
        gap: 12,
      }}
    >
      <div>
        <Trans i18nKey="pages.Diagnostic.buyExplains" ns="radar" />
      </div>
      <div>
        <Trans i18nKey="pages.Diagnostic.diagnoseExplains" ns="radar" />
      </div>
    </div>
  );
};

const PanelDiagnosticButtons: React.FC<PanelDiagnosticButtonsProps> = (
  props
) => {
  const { teamId, getTeams } = props;
  const history = useHistory();
  const { t } = useTranslation();

  const [modalDiagnoseVisible, setModalDiagnoseVisible] =
    useState<boolean>(false);

  const onSendDiagnose = () => {
    setModalDiagnoseVisible(false);
    getTeams();
  };

  const onClickAssess = () => {
    dataLayerClickedEvent(AssessmentClickEventName.ASSESS, {
      ...tagManagerEvent.Assessment.S4L_ARTIST_ASSESSMENT,
    });
    setModalDiagnoseVisible(true);
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 32,
        }}
      >
        <button
          className="botao-roxo"
          onClick={() => history.push("/checkout")}
        >
          {t("pages.Diagnosticos.PriorDiagnosis.comprarCreditos")}
        </button>
        <button className="botao-borda-roxa" onClick={onClickAssess}>
          {t("pages.Diagnosticos.diagnosticar")}
        </button>
        <Popover content={PopoverContent} showArrow={false}>
          <ExclamationCircleOutlined color="#fff" style={{ color: "#fff" }} />
        </Popover>
        <a
          className="botao-exemplo"
          href={REACT_APP_DIAGNOSE_EXAMPLE}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t("pages.Diagnosticos.exemplo")}
        </a>
      </div>
      <ModalDiagnose
        visible={modalDiagnoseVisible}
        onCancel={() => setModalDiagnoseVisible(false)}
        teamId={teamId}
        onSend={onSendDiagnose}
      />
    </>
  );
};

export default PanelDiagnosticButtons;
